module.exports = __webpack_public_path__ + "img/yumi_banner.d8f43a6b.png";